var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-f",attrs:{"id":"public"}},[_c('div',{staticClass:"width-1280 p45"},[_vm._m(0),_vm._v(" "),_c('router-view')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p25"},[_c('img',{attrs:{"src":require("../../../assets/alipaylogo.png")}})])
}]

export { render, staticRenderFns }